module.exports = __webpack_public_path__ + "img/25.20088420.jpg";